import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactImageFallback from "react-image-fallback";
import config from './../../config';
import common from './../../common';
import {
    addOrRemovePlayer,
    triggerHandlePlayerCard,
} from './../../actions/FormationActions';

class ListElement extends Component {
    onPlayerTap = (playerObj, isPlayerInTeam) => {

        if (isPlayerInTeam) {
            let pageNamere = "";
            if (window.location.pathname.indexOf("/manage-team")) {
                pageNamere = "/uclfantasy/my-team/transfers/"
            } else {
                pageNamere = "/uclfantasy/create-team/"
            }
            common.customTracking('Remove Player - Player Listing', pageNamere);
        } else {
            if (this.props.canRecover == true) {
                common.customTracking('Recover Player - Player Listing', '/uclfantasy/my-team/transfers/');
            } else {
                let pageName = "";
                if (window.location.pathname.indexOf("/manage-team")) {
                    pageName = "/uclfantasy/my-team/manage/"
                } else {
                    pageName = "/uclfantasy/create-team/"
                }
                common.customTracking('Add Player - Player Listing', pageName);
            }

        }

        this.props.addOrRemovePlayer(playerObj);
    };
    onPlayerInfo = (e, playerObj) => {
        e.stopPropagation();
        let playerInfoClicked = 'true';
        let pageNamere = "";
        if (window.location.pathname.indexOf("/manage-team")) {
            pageNamere = "/uclfantasy/my-team/transfers/"
        } else {
            pageNamere = "/uclfantasy/create-team/"
        }
        common.customTracking('Player Listing - Player Card', pageNamere);
        this.props.triggerHandlePlayerCard(true, playerObj, playerInfoClicked);
    };

    render() {
        const { player, isPlayerInTeam, isDisabled, style, canRecover, sortBy, playersInTeam, trans, clickButDisabled } = this.props;
        const playerID = player.Id;
        // const playerImg = config.UEFAImgBase + `players/1/2020/324x324/${playerID}.jpg`;
        const playerImg = config.UEFAImgBase + `players/1/2020/75x75/${playerID}.jpg`;
        const UpComingMatchesList = player['UpComingMatchesList'];
        const playerTeamName = player.CCode;
        let vsObj = {};
        let vsTeam = '';
        if (UpComingMatchesList.length) {
            vsObj = UpComingMatchesList[0];
        }
        if (vsObj.hasOwnProperty('VsCCode')) {
            vsTeam = vsObj['VsCCode'];
        }
        let pStatus = player.PStatus;
        let pStatusObj = config.playerStatusObj ? config.playerStatusObj : {};
        let pStatusHeaderClass = pStatusObj[pStatus] ? pStatusObj[pStatus]["playerInfoHeaderClass"] : '';
        let hasStatus = pStatusHeaderClass !== '';
        let elemClassObj = {
            'si-list-item': true,
            'si-flexBox': true,
            'si-selected': isPlayerInTeam,
            'si-disabled-with-opacity': isDisabled,
            'si-recovered': canRecover,
            'si-click-disable': clickButDisabled
        };
        if (hasStatus) {
            elemClassObj[pStatusObj[pStatus]["playerInfoHeaderClass"]] = true;
        }
        const elemClass = common.makeClasses(elemClassObj);
        const title = isDisabled ? { title: this.props.trans['canNot_add'] } : {};
        const valueClass = common.makeClasses({
            'si-list': true,
            'si-plyr-val': true,
            'si-flexBox': true,
            'xxx-xxx': sortBy === 'Value',
        });

        let playerTeamText = <React.Fragment>
            {/* <span className="si-home-team">{ playerTeamName + " " + (vsObj['TLoc'] ? "(" + vsObj['TLoc'] + ")" : "") } </span> */ }
            <span className="si-home-team">{ playerTeamName } </span>
            { vsTeam ? ' ' + this.props.trans.vs + ' ' : null }
            <span>{ vsTeam }</span>
        </React.Fragment>;

        if (vsObj['TLoc'] && vsObj['TLoc'] == "A") {
            playerTeamText = <React.Fragment>

                <span>{ vsTeam }</span>
                { vsTeam ? ' ' + this.props.trans.vs + ' ' : null }
                {/* <span className="si-home-team">{ playerTeamName + " " + (vsObj['TLoc'] ? "(" + vsObj['TLoc'] + ")" : "") } </span> */ }
                <span className="si-home-team">{ playerTeamName } </span>

            </React.Fragment>;
        }

        if (canRecover && playersInTeam.length < config.MAX_PLAYERS_PER_TEAM) {
            playerTeamText = <span className="si-home-team">{ this.props.trans['tapToRecover'] }</span>;
        }
        const clickHandler = isDisabled ? { onClick: () => this.onPlayerTap(player, isPlayerInTeam) } : { onClick: () => this.onPlayerTap(player, isPlayerInTeam) };
        return <div className={ elemClass } key={ playerID }
            { ...clickHandler } { ...title } style={ style }>
            <div className="si-list si-plyr-info si-flexBox" onClick={ (e) => this.onPlayerInfo(e, player) }>
                <div className="si-icon-wrap">
                    <i className="icon-ucl-info" />
                </div>
            </div>
            <div className="si-list si-flexBox">
                <div className="si-plyr-thumbnail">
                    <span className="si-thumbnail">
                        <ReactImageFallback
                            src={ playerImg }
                            initialImage={ config.playerImgBase + "default_player@2x.png" }
                            fallbackImage={ config.playerImgBase + "default_player@2x.png" }
                            alt="" />
                    </span>
                    <div className="si-selected-overlay"><i className="icon-ucl-tick" /></div>
                </div>
                {
                    hasStatus ? <span className="si-status-icon" /> : null
                }
            </div>
            <div className="si-list si-plyr-name si-flexBox">
                <span>{ player['PDName'] }</span>
                <span className="si-match">
                    { playerTeamText }
                </span>
            </div>
            <div className={ valueClass }>
                <div>
                    <span className="si-currency-font">€</span><span>{ player.Value }{ this.props.trans.million }</span>
                </div>
                {/* <div className="si-pos">{this.props.trans[config.positionMap[player.SkillDesc][key]]}</div> */ }
                <div className="si-pos">{ this.props.trans[config.positionMap[player.Skill].key + "_short"] ? this.props.trans[config.positionMap[player.Skill].key + "_short"] : config.positionMap[player.Skill].key }</div>

            </div>

            { sortBy !== 'Value' ? <div className="si-list si-plyr-points">
                { player[sortBy] ? player[sortBy] : 0 }
            </div> : null }

        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addOrRemovePlayer: (player) => dispatch(addOrRemovePlayer(player)),
        triggerHandlePlayerCard: (isPlayerCardVisible, payload, playerInfoClicked) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, payload, playerInfoClicked))
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        playersInTeam: state.formationData.teamData.playersInTeam,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ListElement);


// WEBPACK FOOTER //
// ./src/components/onboarding/ListElement.js